<template>
    <div :class="'social-media-group-popup' + (isEdit ? ' is-edit': '')">
        <div class="row" v-if="allActiveUsers.length">
            <div class="col-7">
                <div class="group-title" v-show="!hideTitle">
                    <h1 class="mb-0 exclude-outside-click edit-d-title project-title" v-show="!editTitle" @click="activateTitleField">{{ socialSeriesDetail.title }}</h1>
                    <textarea
                        ref="editTitleRef"
                        v-show="editTitle"
                        type="text"
                        placeholder="Social Media Series..."
                        class="form-control mb-3 title-field exclude-outside-click h1"
                        v-model="socialSeriesDetail.title"
                        v-click-outside="clickOutsideTitle"
                        @change="updateSocialSeries()"
                    ></textarea>
                </div>
                <!-- <div class="group-id">Series ID: 2022091308</div> -->
                <!--
                <div class="campaign-date">
                    <div class="start-date">
                        <span class="date-label">Start Date:</span>
                        <span class="editable-campaign-date">
                        <div class="custom-field-outside-bg-mobile"></div>
                        <vuejs-datepicker
                            placeholder="No Date"
                            v-model="socialSeriesDetail.start_date"
                            ref="startDatePicker"
                            @input="updateSocialSeries()"
                        >
                            <div slot="beforeCalendarHeader" class="calender-header">
                            <b-button class="remove-dl-btn" variant="text" @click="onRemoveDate('startDate')">Remove Date</b-button>
                            <b-button class="today-btn" variant="text" @click="onToday('startDate')">Today</b-button>
                            </div>
                        </vuejs-datepicker>
                        </span>
                    </div>
                    <div class="end-date">
                        <span class="date-label">End Date: </span>
                        <span class="editable-campaign-date">
                        <div class="custom-field-outside-bg-mobile"></div>
                        <vuejs-datepicker
                            placeholder="No Date"
                            v-model="socialSeriesDetail.end_date"
                            ref="endDatePicker"
                            @input="updateSocialSeries()"
                        >
                            <div slot="beforeCalendarHeader" class="calender-header">
                            <b-button class="remove-dl-btn" variant="text" @click="onRemoveDate('endDate')">Remove Date</b-button>
                            <b-button class="today-btn" variant="text" @click="onToday('endDate')">Today</b-button>
                            </div>
                        </vuejs-datepicker>
                        </span>
                    </div>
                </div>
                -->
                <div
                    class="field-box social-campaign-detail-field"
                    v-for="(field, index) in _.filter(socialSeriesDetail.customFields, {field_key: 'social_series_detail'})"
                >
                    <CustomFields :key="'ssfields'+socialSeriesDetail.id" :detail="socialSeriesDetail" :customField="field" :showLabel="false" :namespace="namespace"/>
                </div>

            </div>
            <div class="col-5">
                <div
                    class="field-box"
                    v-if="typeof socialSeriesDetail == 'object'"
                >
                    <CustomFields :key="'ssfields'+socialSeriesDetail.id" :detail="socialSeriesDetail" :customField="{field_key: 'engagement_manager',field_name: 'engagement_manager', label: 'Engagement Manager'}"  :namespace="namespace"/>
                </div>
                <div
                    class="field-box"
                    v-if="typeof socialSeriesDetail == 'object'"
                >
                    <CustomFields :key="'ssfields'+socialSeriesDetail.id" :detail="socialSeriesDetail" :customField="{field_key: 'project_lead',field_name: 'project_lead', label: 'Project Lead'}"  :namespace="namespace" />
                </div>
                <div class="field-box"
                    v-for="(field, index) in _.filter(socialSeriesDetail.customFields, function(o) {
                        // Hardcoded
                        return !([20, 21, 22, 33, 37].includes(o.field_id)) && o.field_key != 'social_series_detail' && o.field_key != 'social_series_coordinator';
                    })"
                    :key="'ss_field_'+Math.random()"
                >
                    <CustomFields :key="'ssfields'+socialSeriesDetail.id" :detail="socialSeriesDetail" :customField="field" :namespace="namespace"/>
                </div>

                <div class="project--resources">
                    <div class="dropdown project--resources--title">
                        <button
                            title="Add resource"
                            class="add-resource-button exclude-outside-click d-inline-block"
                            id="add-resource-button"
                            data-toggle="dropdown" aria-expanded="false"
                        >Resources</button>
                        <plus-button data-toggle="dropdown" aria-expanded="false" data-reference="parent"></plus-button>
                        <div class="dropdown-menu project--resources--type--menu">
                            <a class="dropdown-item" href="#" v-for="(type,i) in optionsForLinkType" :key="i" @click="addResourceMenuItemClick(type.id, $event)"><img class="link-type-icon" :src="require(`@/csmworkflow/img/${type.icon}`)"> {{type.name}}</a>
                        </div>
                    </div>
                    <div class="project--resources--content">
                        <div class="resource-entry"
                            :class="userCanEditSocialSeries ? 'editable' : 'not-editable'"
                            v-for="(resource, index) in _.filter(socialSeriesDetail.customFields, {field_key: 'link_url'})"
                            :key="'link_url-'+index"
                            v-if="showResourceBox(resource.value,resource.ssfv_id)"
                        >
                            <div class="resource-box__url">
                                <a :href="resource.value" @click="openCopyLinkModal(resource.value, $event, index)" target="_blank" :id="`social-series-resource-${index}`">{{customChildFieldValue('link_label',resource.ssfv_id) || resource.value}}</a>
                                <b-tooltip :target="`social-series-resource-${index}`" noninteractive triggers="manual"><i class="fas fa-check" style="color:'var(--primary)';"></i> Link Copied!</b-tooltip>
                            </div>
                            <a
                            v-b-tooltip.hover
                            title="Edit resource"
                            class="edit-resource-btn"
                            href="#"
                            v-if="userCanEditSocialSeries"
                            @click.prevent="editResource(resource)"
                            >
                            <i class="fas fa-edit"></i>
                            </a>
                            <img class="link-type-icon" :src="require(`@/csmworkflow/img/${getLinkTypeObject(customChildFieldValue('link_type',resource.ssfv_id)).icon}`)" draggable="false">
                            <div class="resource-box__notes" v-if="customChildFieldValue('link_notes',resource.ssfv_id)">{{customChildFieldValue('link_notes',resource.ssfv_id)}}</div>
                        </div>
                    </div>

			        <div class="responsive-edit-modal-controls">
			          <button
			          v-b-tooltip.hover
			          :title="'Delete Series: ' + socialSeriesDetail.title"
			          @click="removeSocialSeries()"
			          class="btn delete-deliverable-btn"
			          v-if="userAbilities.deleteSocialSeries && !socialSeriesDetail.permissions.viewOnly"
			          >
			            <i class="fas fa-trash-alt"></i>
			          </button>
			        </div>


                </div>
            </div>
        </div>

        <!-- Resources modal -->
        <b-modal centered no-close-on-backdrop hide-footer id="createSocialSeriesLinkModal" title="New Resource / Link" @shown="focusLinkModal">
        <CreateLinkModal  ref="refLinkModal" v-bind:link-url="linkUrl" v-bind:link-label="linkLabel" v-bind:link-notes="linkNotes" v-bind:link-type="linkType" :namespace="namespace"/>
        </b-modal>
        <b-modal centered no-close-on-backdrop hide-footer id="editLinkModal" title="Update Resource / Link" @shown="focusEditLinkModal">
        <EditLinkModal  ref="refEditLinkModal" v-bind:link-url="linkUrl" v-bind:link-label="linkLabel" v-bind:link-notes="linkNotes" v-bind:link-type="linkType" v-bind:is-file="editLinkIsFile"  :namespace="namespace"/>
        </b-modal>
        <b-modal centered id="linkCopyLinkModal" title="Copy Link" ok-only ok-title="Done">
        <LinkCopyLinkModal :linkUrl="linkCopyModalValue"  :namespace="namespace"/>
        </b-modal>



        <b-modal v-model="showRemoveSocialSeries" type="warn" title="Confirm Deletion" @ok="onConfirmRemoveSocialSeries" ok-title="Yes, Delete">
          <p>Are you sure you want to delete this social series?</p>
        </b-modal>

    </div>


</template>

<script>
import Datepicker from "vuejs-datepicker";
import { mapActions, mapState } from "vuex";
import CreateLinkModal from "./CreateSocialSeriesLinkModal";
import EditLinkModal from "./EditSocialSeriesLinkModal";
import LinkCopyLinkModal from "../common/LinkCopyLinkModal.vue";
import CustomFields from './SocialSeriesCustomFields.vue';

export default {
    props: ['isEdit','hideTitle','namespace'],
    components: {
        'vuejs-datepicker': Datepicker,
        CreateLinkModal,
        EditLinkModal,
        LinkCopyLinkModal,
        CustomFields
    },
    data() {
        const loggedInUser = {id: localStorage.getItem("userId"), name: localStorage.getItem("user")};
        return {
            editTitle: false,
            emEditing: false,
            plEditing: false,
            budgetEditing: false,
            requisitionNumberEditing: false,
            socialSeries: {
                title: "Social Media Series",
                start_date: this.$moment().format(),
                end_date: null,
                engagement_manager: loggedInUser,
                project_lead: loggedInUser,
                budget: null,
                requisitionNumber: "",
            },
            showRemoveSocialSeries: false,
            // Resources
            linkUrl: null,
            linkLabel: null,
            linkNotes: null,
            linkType: null,
            editLinkIsFile: false,
            linkCopyModalValue: "",
        };
    },
    computed: {
    	...mapState({
    	  state (state) {
    	    return state[this.namespace]
    	  },
    	  allActiveUsers (state, getters) {
    	    return getters[this.namespace + 'allActiveUsers']
    	  },
    	  allCustomFields (state, getters) {
    	    return getters[this.namespace + 'allCustomFields']
    	  },
    	  socialSeriesDetail (state, getters) {
    	    return getters[this.namespace + 'socialSeriesDetail']
    	  },
    	  userAbilities (state, getters) {
    	    return getters['userAbilities']
    	  },
    	}),
        optionsForLinkType() {
            let linkTypeField = this.allCustomFields.find(x => x.id == 37);
            if (!linkTypeField) {
                this.$store.dispatch(this.namespace + "fetchAllCustomFields");
            } else {
                return JSON.parse(linkTypeField.value_set);
            }
		},
        _() {
            return _;
        },
        userCanEditSocialSeries() {
			const userId = localStorage.getItem("userId");
            const socialSeries = this.socialSeriesDetail;

            if (this.userAbilities.accessAllSocialSeries) {
                return this.userAbilities.editSocialSeries;
            }

            let isManager = false;
            if (socialSeries.engagement_manager instanceof Object) {
                isManager = userId == socialSeries.engagement_manager.id;
            } else {
                isManager = userId == socialSeries.engagement_manager;
            }

            return (this.userAbilities.editSocialSeries && isManager);
        },
    },
    methods: {
    	...mapActions({
    	  createSocialSeries (dispatch, payload) {
    	    return dispatch(this.namespace + 'createSocialSeries', payload)
    	  },
    	  updateSocialSeriesFieldValue (dispatch, payload) {
    	    return dispatch(this.namespace + 'updateSocialSeriesFieldValue', payload)
    	  },
    	}),
        activateTitleField() {
            this.editTitle = true;
            let that = this;
            setTimeout(() => {
                that.$refs.editTitleRef.select();
            }, 100);
        },
        clickOutsideTitle() {
            this.editTitle = false;
        },

        showEngagementManager() {
            this.emEditing = true;
            this.$nextTick(() => {
                this.$refs.emSelect.$el.focus();
            })
        },
        showProjectLead() {
            this.plEditing =  true;
            this.$nextTick(() => {
                this.$refs.plSelect.$el.focus();
            })
        },
        changeEngagementManager(v1, v2) {
            
        },
        changeProjectLead() {

        },

        clickOutsideEM() {
            this.emEditing = false;
        },
        clickOutsidePL() {
            this.plEditing = false;
        },
        /*
        onToday(dateType) {
            if (dateType == "startDate") {
                this.socialSeries.start_date = this.$moment().format();
                this.$refs.startDatePicker.close();
            }
            else if (dateType == "endDate") {
                this.socialSeries.end_date = this.$moment().format();
                this.$refs.endDatePicker.close();
            }
        },
        onRemoveDate(dateType) {
            if (dateType == "startDate") {
                this.socialSeries.start_date = null;
                this.$refs.startDatePicker.close();
            }
            else if (dateType == "endDate") {
                this.socialSeries.end_date = null;
                this.$refs.endDatePicker.close();
            }
        },
        */

        createSeries() {
            this.socialSeries.engagement_manager = this.socialSeries.engagement_manager.id;
            this.socialSeries.project_lead = this.socialSeries.project_lead.id;

            this.createSocialSeries(this.socialSeries);

            this.$emit("socialSeriesCreated", this.socialSeries);
        },

        close() {
            this.$emit("socialSeriesClose");
        },


        budgetClick() {
            this.budgetEditing = true;
            setTimeout(() => {
                this.$refs.budgetInput.select();
            }, 100);
        },
        budgetClickOutside() {
            this.budgetEditing = false;
        },

        requisitionNumberClick() {
            this.requisitionNumberEditing = true;
            setTimeout(() => {
                this.$refs.requisitionNumberInput.select();
            }, 100);
        },
        requisitionNumberClickOutside() {
            this.requisitionNumberEditing = false;
        },

        showResourceBox(url, parent_id) {
            let fileId = this.customChildFieldValue('file_id',parent_id);
            return (url != null || fileId != null);
        },
        customChildField(key, parent_id) {
            if (this.socialSeriesDetail.customFields) {
                let obj = _.filter(this.socialSeriesDetail.customFields, {field_key: key, parent_id:parent_id});
                if (obj.length > 0) {
                    // lets add it to the
                    return obj;
                } else {
                    if (key == 'file_id') return null;
                    if (key == 'link_type') return [];
                    // return the global version of the custom field...
                    // let obj = _.filter(this.allCustomFields, {field_key: key});
                    let field = _.filter(this.allCustomFields, {field_key: key});
                    obj = {};
                    obj.id = null;
                    obj.parent_id = this.socialSeriesDetail.customFields[index].id;
                    obj.social_series_id = this.socialSeriesDetail.customFields[index].social_series_id;
                    obj.editing = false;
                    obj.field_id = field[0].id;
                    obj.field_key = field[0].field_key;
                    obj.field_parent_id = field[0].parent_id;
                    obj.field_type = field[0].field_type;
                    obj.note = field[0].note;
                    obj.value = null;
                    obj.label = field[0].label;
                    obj.value_set = field[0].value_set;
                    obj.updated_at = this.socialSeriesDetail.customFields[index].updated_at;
                    return [obj];
                }
            }
            return [];
        },
        customChildFieldValue(key, parent_id) {
            if (this.socialSeriesDetail.customFields) {
                let obj = _.filter(this.socialSeriesDetail.customFields, {field_key: key, parent_id:parent_id});
                if (obj.length > 0) {
                return obj[0].value;
                } else {
                return null;
                }
            }
            return null;
        },

        // Resources
        addResourceMenuItemClick(typeId, e) {
            e.preventDefault();
            this.addResource(typeId);
        },
        editResource(resource) {
            this.linkUrl = resource;
            let label =  this.customChildField('link_label', resource.ssfv_id);
            if (label.length > 0) {
                this.linkLabel = label[0];
            } else {
                this.linkLabel = {};
            }
            let notes =  this.customChildField('link_notes', resource.ssfv_id);
            if (notes.length > 0) {
                this.linkNotes = notes[0];
            } else {
                this.linkNotes = {};
            }
            let type = this.customChildField('link_type', resource.ssfv_id);
            if (type.length > 0) {
                this.linkType = type[0];
            } else {
                this.linkType = {
                id:null,
                field_id:37,
                social_series_field_id: _.filter(this.socialSeriesDetail.customFields, {field_key: 'link_type'})[0]?.socialSeriesFieldId,
                parent_field_id: 20,
                field_key: "link_type",
                field_type: "select",
                parent_id: null,
                social_series_id: this.socialSeriesDetail.id,
                value:1
                };
            }
            let fileId = this.customChildField('file_id', resource.ssfv_id);
            this.editLinkIsFile = Boolean(fileId);
            this.$bvModal.show("editLinkModal");
        },
        addResource(typeId = 1) {
            this.linkUrl = {
                id:null,
                field_id:20,
                social_series_field_id:_.filter(this.socialSeriesDetail.customFields, {field_key: 'link_url'})[0].socialSeriesFieldId,
                parent_field_id:null,
                field_key:"link_url",
                field_type:"text",
                parent_id:null,
                social_series_id: this.socialSeriesDetail.id,
                value:null
            };
            this.linkLabel = {
                id:null,
                field_id:21,
                social_series_field_id:_.filter(this.socialSeriesDetail.customFields, {field_key: 'link_label'})[0].socialSeriesFieldId,
                parent_field_id:20,
                field_key:"link_label",
                field_type:"text",
                parent_id:null,
                social_series_id: this.socialSeriesDetail.id,
                value:null
            };
            this.linkNotes = {
                id:null,
                field_id:22,
                social_series_field_id:_.filter(this.socialSeriesDetail.customFields, {field_key: 'link_notes'})[0].socialSeriesFieldId,
                parent_field_id:20,
                field_key:"link_notes",
                field_type:"text",
                parent_id:null,
                social_series_id: this.socialSeriesDetail.id,
                value:null
            };
            this.linkType = {
                id:null,
                field_id:37,
                social_series_field_id:_.filter(this.socialSeriesDetail.customFields, {field_key: 'link_type'})[0].socialSeriesFieldId,
                parent_field_id:20,
                field_key:"link_type",
                field_type:"select",
                parent_id:null,
                social_series_id: this.socialSeriesDetail.id,
                value:typeId
            };
            this.$bvModal.show("createSocialSeriesLinkModal");
        },
        focusLinkModal() {
            this.$refs.refLinkModal.focusMyElement();
        },
        focusEditLinkModal() {
            this.$refs.refEditLinkModal.focusMyElement();
        },
        removeSocialSeries() {
          this.showRemoveSocialSeries = true;
        },

        onConfirmRemoveSocialSeries() {
          if (this.socialSeriesDetail.id) {
            let that = this;
            let socialSeriesId = this.socialSeriesDetail.id;
            let socialSeriesTemplateId = this.socialSeriesDetail.socialSeries_template_id;
            this.$store.dispatch(this.namespace + "removeSocialSeries", { socialSeriesId:this.socialSeriesDetail.id }).then(function() {
              that.$bvModal.hide("editSocialSeriesModal");
              // TODO: removing a socialSeries should only remove it from the list, not replace entire list.

              that.$store.dispatch(that.namespace + 'fetchSocialSeries').then(function() {
                toast.hide();

                // if (socialSeriesTemplateId == 1) {
                // 	that.$store.dispatch(that.namespace + 'manageUndoActivation', 'Media call deleted.');
                // } else {
                // }
                that.$store.dispatch(that.namespace + 'manageUndoActivation', 'SocialSeries deleted.');

              	// that.$store.dispatch(that.namespace + 'fetchProjectSocialSeries');
              });
            }).catch((error) => {
            });;
          }
        },

        updateSocialSeries() {
            this.$store.dispatch(this.namespace + "updateSocialSeries", this.socialSeriesDetail);
        },

        getLinkTypeObject(id) {
            if (id == null) id = 1;
            const r = this.optionsForLinkType.find(x => x.id == id);
            return r;
        },

        openCopyLinkModal(link, e, i) {
            if (!link.includes("\\")) {
                return;
            }
            e.preventDefault();
            this.copyLink(link, i);
        },
        async copyLink(link, resourceId) {
            clearTimeout(this.linkCopyLinkTimeouts[resourceId]);
            Object.keys(this._.filter(this.socialSeriesDetail.customFields, {field_key: 'link_url'})).forEach(x => {
                if (x == resourceId) return;
                this.$root.$emit('bv::hide::tooltip', 'social-series-resource-' + x);
            })

            const navPer = await navigator.permissions.query({name: "clipboard-write"});
            if (navPer.state == "granted" || navPer.state == "prompt") {
                try {
                    await navigator.clipboard.writeText(link);
                } catch {
                    console.error("clipboard API error. Cannot copy to clipboard.");
                    this.legacyCopyMethod(link);
                }
            } else {
                this.legacyCopyMethod(link);
            }

            this.$root.$emit('bv::show::tooltip', 'social-series-resource-' + resourceId);
            this.linkCopyLinkTimeouts[resourceId] = setTimeout(() => {
                this.$root.$emit('bv::hide::tooltip', 'social-series-resource-' + resourceId);
            }, 2000);
        },
    },
    mounted() {
        //console.log(this.socialSeriesDetail);
    },
}
</script>
<style scoped>

.social-media-group-popup .field-box.social-campaign-detail-field > div, .social-media-group-popup .field-box.social-series-detail-field > div {
margin-top: 16px;
}

.campaign-details {
	padding-top:0px;
}
.type-label {
	font-weight:600;
	text-transform:uppercase;

    color: var(--primary);
display:block;
font-weight: 600;
font-size: 1em;
text-transform:uppercase;
}
h1 {
	font-size:22px;
}
h1.edit-d-title::after {
	color: var(--hover-grey);
	background:transparent;
	}

textarea.title-field {
	font-size:22px;
}



</style>
